export const OUT_APP_JOIN_REQUEST = 'app-join-request';
export const IN_APP_JOIN_BROADCAST = 'app-join-broadcast';
export const OUT_APP_LEAVE_REQUEST = 'app-leave-request';
export const IN_APP_LEAVE_BROADCAST = 'app-leave-broadcast';

/**
 * Room management socket event type
 */
export const OUT_BREAKOUT_ROOM_MOVE_REQUEST = 'breakout-room-move-request';
export const IN_BREAKOUT_ROOM_MOVE_BROADCAST = 'breakout-room-move-broadcast';
export const OUT_BREAKOUT_ROOM_REMOVE_REQUEST = 'breakout-room-remove-request';
export const IN_BREAKOUT_ROOM_REMOVE_BROADCAST = 'breakout-room-remove-broadcast';
export const OUT_BREAKOUT_ASSIGN_ID_REQUEST = 'breakout-room-assign-id-request';
export const IN_BREAKOUT_ASSIGN_ID_BROADCAST = 'breakout-room-assign-id-broadcast';
export const OUT_BREAKOUT_ROOM_UPDATE_REQUEST = 'breakout-room-update-request';
export const IN_BREAKOUT_ROOM_UPDATE_BROADCAST = 'breakout-room-update-broadcast';
export const OUT_BREAKOUT_ROOM_ALLOW_SPEAK_REQUEST = 'breakout-room-allow-speak-request';
export const IN_BREAKOUT_ROOM_ALLOW_SPEAK_BROADCAST = 'breakout-room-allow-speak-broadcast';
export const OUT_BREAKOUT_ROOM_AUTO_ASSIGN_REQUEST = 'breakout-room-automatic-assign-request';
export const OUT_BREAKOUT_ROOM_TIME_EXTEND_REQUEST = 'breakout-room-time-extend-request';
export const IN_BREAKOUT_ROOM_TIME_EXTEND_BROADCAST = 'breakout-room-time-extend-broadcast';
export const OUT_BREAKOUT_ROOM_OPEN_REQUEST = 'breakout-room-open-request';
export const IN_BREAKOUT_ROOM_OPEN_BROADCAST = 'breakout-room-open-broadcast';

export const IN_BREAKOUT_ROOM_AUTO_ASSIGN_BROADCAST = 'breakout-room-automatic-assign-broadcast';

export const IN_ROOM_CREATE_BROADCAST = 'room-create-broadcast';
export const IN_UPDATE_ROOM_BROADCAST = 'room-update-broadcast';
export const IN_ROOM_DELETE_BROADCAST = 'room-delete-broadcast';
export const IN_ROOM_UPDATE_SETTINGS_BROADCAST = 'room-update-setting-broadcast';
export const OUT_JOIN_ROOM_REQUEST = 'room-join-request';
export const IN_JOIN_ROOM_BROADCAST = 'room-join-broadcast';
export const OUT_JOIN_WAITING_ROOM_REQUEST = 'room-join-waiting-request';
export const IN_JOIN_WAITING_ROOM_BROADCAST = 'room-join-waiting-broadcast';
export const OUT_LEAVE_ROOM_REQUEST = 'room-leave-request';
export const IN_LEAVE_ROOM_BROADCAST = 'room-leave-broadcast';
export const IN_END_ROOM_BROADCAST = 'room-end-broadcast';
export const IN_ROOM_ADMIT_RESPONSE = 'room-admit-response';
export const OUT_ROOM_ADMIT_REQUEST = 'room-admit-request';
export const OUT_ROOM_ACTIVE_CHAT_REQUEST = 'room-active-chat-request';
export const IN_ROOM_ACTIVE_CHAT_BROADCAST = 'room-active-chat-broadcast';
export const OUT_ROOM_ACTIVE_CC_REQUEST = 'room-active-cc-request';
export const IN_ROOM_ACTIVE_CC_BROADCAST = 'room-active-cc-broadcast';

export const OUT_CHAT_REQUEST = 'chat-request';
export const IN_CHAT_BROADCAST = 'chat-broadcast';

/**
 * Emoji socket event type
 */
export const OUT_EMOJI_REQUEST = 'room-emoji-request';
export const IN_EMOJI_BROADCAST = 'room-emoji-broadcast';
export const OUT_REACTION_REQUEST = 'room-reaction-request';
export const IN_REACTION_BROADCAST = 'room-reaction-broadcast';
export const OUT_EMOJI_WEBINAR_REQUEST = 'room-emoji-webinar-request';
export const IN_EMOJI_WEBINAR_BROADCAST = 'room-emoji-webinar-broadcast';
export const IN_ROOM_RECORDING_BROADCAST = 'room-recording-broadcast';

/**
 * Whiteboard socket event type
 */
export const OUT_WHITEBOARD_ACTIVE_REQUEST = 'whiteboard-active-request';
export const IN_WHITEBOARD_ACTIVE_BROADCAST = 'whiteboard-active-broadcast';
export const OUT_WHITEBOARD_UPDATE_REQUEST = 'whiteboard-update-request';
export const IN_WHITEBOARD_UPDATE_BROADCAST = 'whiteboard-update-broadcast';

export const OUT_KICK_REQUEST = 'kickout-request';
export const IN_KICK_RESPONSE = 'kickout-response';
export const OUT_ASSIGN_HOST_REQUEST = 'assign-host-request';